<div class="alert-modal__wrapper">
  <div class="alert-modal__content" [ngClass]="'alert-modal__' + type">
    <div class="alert-modal__header">
      <div class="alert-modal__icon">
        <ion-icon [name]="getIconName()"></ion-icon>
      </div>
    </div>

    <div *ngIf="title" class="alert-modal__title">{{ title }}</div>

    <div class="alert-modal__message">{{ message }}</div>

    <div class="alert-modal__buttons">
      <button class="alert-modal__button" (click)="onClose()">
        {{ 'BUTTONS.ACCEPT' | translate }}
      </button>
      <button *ngIf="showCancel" class="alert-modal__button" (click)="onCancel()">
        {{ 'BUTTONS.CLOSE' | translate }}
      </button>
    </div>
  </div>
</div>